import React, { FC, useEffect } from 'react';
import Layout from 'antd/es/layout/layout';
import { Route, Routes } from 'react-router-dom';
import { Header, PrivateLayout } from 'common/components';
import { ERoute } from 'common/const/enum';
import { useAppDispatch } from 'common/hooks';
import { Login } from 'app/pages';

export const App: FC = () => {
  const { auth: authDispatch } = useAppDispatch();

  const { initAuth } = authDispatch;

  useEffect(() => {
    initAuth();
  }, []);

  return (
    <Layout>
      <Header />

      <Routes>
        <Route path={ERoute.Login} element={<Login />} />
        <Route path="*" element={<PrivateLayout />} />
      </Routes>
    </Layout>
  );
};
